import { useQuery } from '@tanstack/react-query';
import { getApiClient } from '@treneo/infrastructure/api';

import { ORGANIZATION_TRAINERS_BY_DADESKTOP_QUERY_KEY } from '../courses-query-keys';

export const getOrganizationTrainersByDaDesktopIdQueryOptions = (daDesktopId: number) => ({
  queryKey: [ORGANIZATION_TRAINERS_BY_DADESKTOP_QUERY_KEY, daDesktopId] as const,
  queryFn: async () => {
    const res = await getApiClient().getInstance().get<{
      trainers: Array<{ id: string; label: string }>;
    }>(`/api/organizations/by-dadesktop-id/${daDesktopId}/trainers`);
    return res.data;
  }
});

export const useOrganizationTrainersByDaDesktopIdQuery = (
  daDesktopId: number,
  options?: { enabled?: boolean }
) =>
  useQuery({
    ...getOrganizationTrainersByDaDesktopIdQueryOptions(daDesktopId),
    enabled: options?.enabled !== false && daDesktopId > 0
  });
